import React from 'react'

import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Text,
} from '@indeed/ifl-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showModal } from 'syft-acp-core/lib/modals'
import { hideModal } from 'syft-acp-core/store/modals/actions'
import { getModal$ } from 'syft-acp-core/store/modals/selectors'
import { ListingWarningModalProps as Props } from './ListingWarningModal.types'
import { Warning } from './Warning.types'

export const storeConnector = connect(
  state => ({
    modal: getModal$(state.modals)('listingWarningModal'),
  }),
  dispatch => ({
    actions: {
      ...bindActionCreators({ showModal, hideModal }, dispatch),
    },
  }),
)

const ListingWarningModal = ({ actions, modal }: Props) => {
  const handleOnExit = () => {
    actions.hideModal('listingWarningModal')
  }

  return (
    <Dialog open={modal.isShown} onOpenChange={() => handleOnExit()}>
      <DialogContent>
        <DialogHeader>Warning</DialogHeader>
        <DialogBody>
          {modal.options.warningData?.map((warning: Warning) => {
            return (
              <>
                <Text as="p" level={4}>
                  {warning.heading}
                </Text>
                {warning?.messages?.map((warningMessage: string) => {
                  return (
                    <Text as="p" level={3}>
                      {warningMessage}
                    </Text>
                  )
                })}
              </>
            )
          })}
        </DialogBody>
        <DialogFooter>
          <Button onClick={handleOnExit}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default storeConnector(ListingWarningModal)
